import { Button, Icon, useToast } from '@efira/ui';

import { useAuthConfig } from '../api/queries';
import { signIn } from '../auth/client';

/**
 * Вход через провайдера: кнопка есть ТОЛЬКО у настроенного.
 *
 * ПЕРЕМЕНА ПРАВИЛА, а не его нарушение. Правило 1 видимости
 * (`docs/ARCHITECTURE.md`, 4.2-а) требует показывать недоступное неактивным
 * с объяснением - оно про возможности, которые у человека БЫЛИ или ещё
 * будут. Способ входа - другое: постоянно неактивная кнопка «Продолжить с
 * Google» рекламирует то, чего на этом сервере нет вовсе, и первое, что
 * делает новый человек, - жмёт её. Решение владельца 2026-09-20, запись в
 * `docs/DECISIONS.md`.
 *
 * На боевом сервере `GOOGLE_CLIENT_ID` не задан - значит кнопки Google там
 * нет. Отсутствие ключей пишется в журнал один раз при старте, а не молчит.
 */
const PROVIDERS = [
  { id: 'google' as const, title: 'Продолжить с Google', icon: 'globe' as const },
  { id: 'discord' as const, title: 'Продолжить с Discord', icon: 'chat' as const },
];

export function SocialButtons() {
  const config = useAuthConfig();
  const toast = useToast();

  const available = PROVIDERS.filter((provider) => config.data?.[provider.id] === true);

  if (available.length === 0) {
    /* Ни одного провайдера: разделителя «или» тоже нет - он отделял бы
       пустоту от формы. */
    return null;
  }

  return (
    <>
      <div className="text-foreground/80 flex items-center gap-3 text-sm" aria-hidden="true">
        <hr className="border-foreground/15 flex-1" />
        или
        <hr className="border-foreground/15 flex-1" />
      </div>

      {available.map((provider) => (
        <Button
          key={provider.id}
          variant="secondary"
          block
          data-auth={provider.id}
          icon={<Icon name={provider.icon} />}
          onClick={() => {
            signIn
              .social({ provider: provider.id, callbackURL: `${window.location.origin}/app` })
              .then((result) => {
                if (result.error) {
                  toast.show({
                    tone: 'error',
                    title: 'Провайдер не ответил',
                    text: result.error.message ?? 'Попробуйте ещё раз или войдите по почте.',
                  });
                }
              })
              .catch(() => {
                toast.show({
                  tone: 'error',
                  title: 'Не удалось связаться с провайдером',
                  text: 'Проверьте соединение или войдите по почте.',
                });
              });
          }}
        >
          {provider.title}
        </Button>
      ))}
    </>
  );
}
